/* Keep theme-local third-party purchase labels in Italian. Catalog and app settings are unchanged. */
(() => {
  const language = document.documentElement.lang.split('-')[0];
  if (!['it', 'de', 'en'].includes(language)) return;
  const exact = new Map(language === 'it' ? [
    ['Get more, save more 🎉', 'Più acquisti, più risparmi'],
    ['Get more, save more', 'Più acquisti, più risparmi'],
    ['Most popular ⚡', 'Il più scelto'],
    ['Best savings 💰', 'Il massimo risparmio'],
    ['Original price', 'Prezzo originale'],
    ['You save', 'Risparmi'],
    ['Quantity discount selector', 'Sconti per quantità'],
    ['Quantity discount tiers', 'Scegli la quantità'],
    ['Previous', 'Precedente'],
    ['Next', 'Successivo'],
    ['Drawer Cart', 'Carrello']
  ] : language === 'de' ? [
    ['promis paste senza fluoro | Protezione Carie', 'Promis Paste – Ohne Fluorid | Kariesschutz']
  ] : [
    ['promis paste senza fluoro | Protezione Carie', 'Promis Paste – Fluoride-Free | Cavity Protection']
  ]);
  function italian(text) {
    const trimmed = text.trim();
    let translated = exact.get(trimmed);
    if (language === 'it' && !translated && /^Buy \d+\+?$/.test(trimmed)) translated = trimmed.replace('Buy ', 'Acquista ');
    if (language === 'it' && !translated && /^Get \d+(?:[.,]\d+)?% off$/.test(trimmed)) translated = trimmed.replace(/^Get (.+)% off$/, 'Risparmia il $1%');
    if (language === 'it' && !translated && /^You save /.test(trimmed)) translated = trimmed.replace(/^You save /, 'Risparmi ');
    if (language === 'it' && !translated && /^(?:€[\d.,]+\s*)?each$/.test(trimmed)) translated = trimmed.replace('each', 'cad.');
    return translated ? text.replace(trimmed, translated) : text;
  }
  const observed = new WeakSet();
  function translateWidget(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      const node = walker.currentNode;
      const translated = italian(node.nodeValue);
      if (translated !== node.nodeValue) node.nodeValue = translated;
    }
    root.querySelectorAll('[aria-label], [alt], [title]').forEach(node => {
      for (const attribute of ['aria-label', 'alt', 'title']) {
        const value = node.getAttribute(attribute);
        if (!value) continue;
        const translated = italian(value);
        if (translated !== value) node.setAttribute(attribute, translated);
      }
    });
  }
  function scan(node) {
    if (!(node instanceof Element)) return;
    const roots = [...node.querySelectorAll('#lb-vd-cards, .jdgm-carousel-wrapper, .jdgm-carousel')];
    if (node.matches('#lb-vd-cards, .jdgm-carousel-wrapper, .jdgm-carousel')) roots.push(node);
    for (const root of roots) {
      if (observed.has(root)) continue;
      observed.add(root);
      translateWidget(root);
      new MutationObserver(() => translateWidget(root)).observe(root, { childList: true, subtree: true, characterData: true });
    }
    node.querySelectorAll('[aria-label="Previous"],[aria-label="Next"]').forEach(button => {
      button.setAttribute('aria-label', italian(button.getAttribute('aria-label')));
    });
  }
  scan(document.body);
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(scan)))
    .observe(document.body, { childList: true, subtree: true });
})();
